import { Typography } from "@mui/material";

const Header = () => {
  return (
    <Typography variant="h2" align="center" color="primary">
      Todo App
    </Typography>
  );
};

export default Header;
